module.exports = __webpack_public_path__ + "static/media/hydration_success_icon.c305a326.svg";